// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19RIE","col":"styles_col__3t2yk"};